export enum CertificationValuationAccountingCategoryEnum {
  DRAFT = "DRAFT",
  SENT = "SENT",
  APPROVED = "APPROVED",
  INVOICE_DELIVERY = "INVOICE_DELIVERY",
  PARTIALLY_INVOICED = "PARTIALLY_INVOICED",
  BILLED = "BILLED",
  WITHOUT_CERTIFICATION = "WITHOUT_CERTIFICATION",
  INTERNAL_PROJECTS = "INTERNAL_PROJECTS",
}

export const CERTIFICATION_VALUATION_ACCOUNTING_CATEGORY_ORDER: CertificationValuationAccountingCategoryEnum[] = [
  CertificationValuationAccountingCategoryEnum.DRAFT,
  CertificationValuationAccountingCategoryEnum.SENT,
  CertificationValuationAccountingCategoryEnum.APPROVED,
  CertificationValuationAccountingCategoryEnum.INVOICE_DELIVERY,
  CertificationValuationAccountingCategoryEnum.PARTIALLY_INVOICED,
  CertificationValuationAccountingCategoryEnum.BILLED,
  CertificationValuationAccountingCategoryEnum.WITHOUT_CERTIFICATION,
  CertificationValuationAccountingCategoryEnum.INTERNAL_PROJECTS,
];

export const getCertificationValuationAccountingCategoryLabel = (
  category: CertificationValuationAccountingCategoryEnum,
): string => {
  switch (category) {
    case CertificationValuationAccountingCategoryEnum.DRAFT:
      return "Borrador";
    case CertificationValuationAccountingCategoryEnum.SENT:
      return "Enviado";
    case CertificationValuationAccountingCategoryEnum.APPROVED:
      return "Aprobado";
    case CertificationValuationAccountingCategoryEnum.INVOICE_DELIVERY:
      return "Pasado a facturar";
    case CertificationValuationAccountingCategoryEnum.PARTIALLY_INVOICED:
      return "Parcialmente entregado";
    case CertificationValuationAccountingCategoryEnum.BILLED:
      return "Facturado";
    case CertificationValuationAccountingCategoryEnum.WITHOUT_CERTIFICATION:
      return "Sin certificación";
    case CertificationValuationAccountingCategoryEnum.INTERNAL_PROJECTS:
      return "Proyectos internos";
    default:
      return category ?? "";
  }
};

export const getCertificationValuationAccountingCategoryOptions = (): { label: string; value: string }[] =>
  CERTIFICATION_VALUATION_ACCOUNTING_CATEGORY_ORDER.map((category) => ({
    label: getCertificationValuationAccountingCategoryLabel(category),
    value: category,
  }));
